'use strict';

module.exports = html;

function html(node) {
  return node.value;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/html.js
// module id = 299
// module chunks = 96961042003272 139266963665775